import { render } from "./projectext1.vue?vue&type=template&id=65373f89&scoped=true"
import script from "./projectext1.vue?vue&type=script&lang=js"
export * from "./projectext1.vue?vue&type=script&lang=js"

import "./projectext1.vue?vue&type=style&index=0&id=65373f89&scoped=true&lang=css"

import exportComponent from "G:\\zhongfu\\web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65373f89"]])

export default __exports__